import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyCY4btjFZhwbw0nZLJUdP8rVWlf0SZRtQs',
  authDomain: 'beetle-tanzania.firebaseapp.com',
  projectId: 'beetle-tanzania',
  storageBucket: 'beetle-tanzania.firebasestorage.app',
  messagingSenderId: '677210804570',
  appId: '1:677210804570:web:ea5102ac8d85b49b9b2363',
  measurementId: 'G-K11D9E3DZV',
};

const app = initializeApp(firebaseConfig);

// getMessaging() fails in browsers/environments that don't support Service Workers
let messaging = null;
isSupported().then((supported) => {
  if (supported) messaging = getMessaging(app);
});

export { app, messaging, isSupported, getMessaging };
